import React, { useEffect } from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { useSelector } from 'react-redux';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { OrganizationTracker } from './OrganizationTracker';
import { OrganizationList } from './OrganizationList';
import { useApiHealthCheck } from '@src/hooks/useApiHealthCheck';
import { useDSUserInfo } from '@src/hooks/useDsUserInfo';
import { DeniedConnectToOrganization } from './DeniedConnectToOrg';
import { ConnectToOrganizationV2 } from './ConnectToOrganization';

const Wrapper = styled('div', {
  marginTop: '32px',
});

export const OrganizationApi = () => {
  const [dsUserInfo, getDSUserInfo] = useDSUserInfo();
  const [apiHealthCheck, getApiHealthCheck] = useApiHealthCheck();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const userStatus = dsUserInfo?.data?.status;

  useEffect(() => {
    if (userInfo.uuid !== '') {
      getDSUserInfo({ userInfo });
      getApiHealthCheck({ userInfo });
    }
  }, [userInfo]);

  const getDisplayComponent = () => {
    switch (userStatus) {
      case 'ACTIVE':
        return <OrganizationList orgUserInfo={dsUserInfo.data} />;
      case 'PENDING':
      case 'DENIED':
        return (
          <Card>
            <div>
              {userStatus === 'PENDING' ? (
                <OrganizationTracker currentStep={2} />
              ) : (
                <DeniedConnectToOrganization />
              )}
            </div>
          </Card>
        );
      default:
        return <ConnectToOrganizationV2 />;
    }
  };

  return (
    <Wrapper>
      <LoadingOverlay
        loadingTitle="Please Wait"
        loadingMessage="Please wait while we retrieve your data."
        ariaLoadingLabel="Example loading aria label"
        isLoading={apiHealthCheck.loading || dsUserInfo.loading}
        width="40%"
      >
        {getDisplayComponent()}
      </LoadingOverlay>
    </Wrapper>
  );
};
